/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getHead.defs.js'
export * as $defs from './getHead.defs.js'
